export default __webpack_public_path__ + "static/hw_ff_ssd1306-303305bdd8f74226b3cbc9e10f81f7ac.png";